export default "__VITE_ASSET__BJfk4lUW__"